<template>
  <div id="report">
    <header-top :headerText="headerText" showBack></header-top>
    <main class="report-main">
      <div class="main-top">
        <div class="top-left">
          <el-button type="primary">下载</el-button>
          <el-select class="filter-search" v-model="query.type" clearable placeholder="全部人员">
            <el-option
              v-for="item in dutyTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <treeselect
            noOptionsText="未找到对应数据"
            noResultsText="未找到对应数据"
            v-model="org"
            value-consists-of="BRANCH_PRIORITY"
            :multiple="false"
            :options="orgList"
            :normalizer="normalizer"
            :flatten-search-results="false"
            :value="config"
            placeholder="选择部门"
          />

          <el-select
            v-model="searchDateType"
            @change="selectsearchDateType"
            placeholder="请选择"
            class="search-type"
          >
            <el-option
              v-for="item in searchDateTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-date-picker
            class="filter-date"
            v-if="searchDateType !== '全部时间'"
            align="center"
            v-model="query.dateRange"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </div>
      </div>
      <el-table :data="peopleList">
        <el-table-column type="selection" width="50" />
        <el-table-column label-class-name="tab-tit" label="姓名" width="100" align="center">
          <template slot-scope="scope">
            <div class="name-worknum">
              <div>
                <span>{{ scope.row.name }}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label-class-name="tab-tit"
          prop="sex"
          label="性别"
          width="80"
          align="center"
        />

        <el-table-column
          prop="org"
          label-class-name="tab-tit"
          label="部门"
          min-width="200"
          align="center"
        />
        <el-table-column
          prop="post"
          label-class-name="tab-tit"
          label="职务"
          width="100"
          align="center"
        />
        <el-table-column label-class-name="tab-tit" label="职级" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.rank | nullValue }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label-class-name="tab-tit"
          v-if="type=='员工通讯录'"
          label="手机号"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.phone | nullValue }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label-class-name="tab-tit"
          v-if="type=='员工通讯录'"
          label="微信号"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.weChart | nullValue }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label-class-name="tab-tit"
          v-if="type=='员工通讯录'"
          label="QQ号"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.qq | nullValue }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label-class-name="tab-tit"
          v-if="type=='员工通讯录'"
          label="邮箱"
          width="160"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.email | nullValue }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label-class-name="tab-tit"
          v-if="type=='员工通讯录'"
          label="紧急联系人"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.emergencyContact | nullValue }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label-class-name="tab-tit"
          v-if="type=='员工通讯录'"
          label="与员工关系"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.relationship | nullValue }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label-class-name="tab-tit"
          v-if="type=='员工通讯录'"
          label="紧急联系人电话"
          width="120"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.emergencyContactPhone | nullValue }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label-class-name="tab-tit"
          v-if="type=='员工居住地址'"
          label="家庭住址"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.address | nullValue }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label-class-name="tab-tit"
          v-if="type=='员工居住地址'"
          label="籍贯"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.nativePlace | nullValue }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label-class-name="tab-tit"
          v-if="type=='员工生日'"
          label="生日"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.birthday | nullValue }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label-class-name="tab-tit"
          v-if="type=='员工学历'"
          label="员工学历"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.education | nullValue }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label-class-name="tab-tit"
          v-if="type=='员工惩罚表'"
          label="员工奖惩时间"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.rewardutc | nullValue }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label-class-name="tab-tit"
          v-if="type=='员工惩罚表'"
          label="员工奖惩类型"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.rewardType | nullValue }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label-class-name="tab-tit"
          v-if="type=='员工惩罚表'"
          label="员工奖惩描述"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.describedescribedescribedescribedescribe | nullValue }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label-class-name="tab-tit"
          v-if="type=='员工学历'"
          label="员工状态"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.state | nullValue }}</span>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="loading-box" v-if="isLoading">
            <img src="../../../../assets/image/loading.png" alt="loading" class="loading-ico" />
            数据加载中...
          </div>
          <div class="empty-box" v-if="!isLoading&&!peopleList.length">列表为空</div>
        </template>
      </el-table>
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="query.pageIndex"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="query.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </main>
  </div>
</template>

<script>
import headerTop from "@/components/HeaderTop";
// import { peopleList } from "@/http/api/employe";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { getOrgAllTree } from "@/http/api/organization";
import { tree } from "@/utils/tree";
export default {
  components: {
    headerTop,
    Treeselect
  },
  data() {
    return {
      headerText: this.$route.query.name,
      type: this.$route.query.name,
      changeForm: [{}],
      searchVal: "",
      query: {
        limit: 30,
        pageIndex: 1,
        dateRange: "",
        type: ""
      },
      normalizer(node) {
        //console.log(node, 2222222);
        if (node.data && node.data.id) {
          return {
            id: node.data.name,
            label: node.data.name,
            children: node.children
          };
        }
      },
      config: ["disabled-checked"],
      total: 1,
      org: null,
      orgList: [],
      isLoading: false,
      userTypeFilters: [
        { text: "全部类型", value: "UserAdmin" },
        { text: "网站用户", value: "User" },
        { text: "后台用户", value: "Admin" }
      ],
      searchDateType: "全部时间",
      //搜索类型选择数据
      searchDateTypeOptions: [
        {
          key: "全部时间",
          value: "全部时间"
        },
        {
          key: "入职时间",
          value: "入职时间"
        },
        {
          key: "转正时间",
          value: "转正时间"
        },
        {
          key: "离职时间",
          value: "离职时间"
        }
      ],
      dutyTypes: [
        {
          value: "业务",
          label: "业务"
        },
        {
          value: "职能",
          label: "职能"
        }
      ],
      peopleList: [
        {
          name: "张三",
          sex: "男",
          org: "弘业祥盛街A店A组",
          post: "经纪人",
          rank: "实习经纪人",
          phone: "15512212222",
          email: "1145698765@qq.com",
          weChart: "15512212222",
          qq: "1145698765",
          emergencyContact: "赵四",
          relationship: "朋友",
          emergencyContactPhone: "18818818888",
          address: "郑州金水区熊二河路",
          nativePlace: "郑州金水区熊二河路",
          birthday: "1993-09-12",
          state: "正式员工",
          education: "本科",
          rewardutc: "2020-06-15",
          rewardType: "升职",
          describe: "describedescribedescribedescribedescribe"
        },
        {
          name: "张三",
          sex: "男",
          org: "弘业祥盛街A店A组",
          post: "经纪人",
          rank: "实习经纪人",
          phone: "15512212222",
          email: "1145698765@qq.com",
          weChart: "15512212222",
          qq: "1145698765",
          emergencyContact: "赵四",
          relationship: "朋友",
          emergencyContactPhone: "18818818888",
          address: "郑州金水区熊二河路",
          nativePlace: "郑州金水区熊二河路",
          birthday: "1993-09-12",
          state: "正式员工",
          education: "本科",
          rewardutc: "2020-06-15",
          rewardType: "升职",
          describe: "describedescribedescribedescribedescribe"
        },
        {
          name: "张三",
          sex: "男",
          org: "弘业祥盛街A店A组",
          post: "经纪人",
          rank: "实习经纪人",
          phone: "15512212222",
          email: "1145698765@qq.com",
          weChart: "15512212222",
          qq: "1145698765",
          emergencyContact: "赵四",
          relationship: "朋友",
          emergencyContactPhone: "18818818888",
          address: "郑州金水区熊二河路",
          nativePlace: "郑州金水区熊二河路",
          birthday: "1993-09-12",
          state: "正式员工",
          education: "本科",
          rewardutc: "2020-06-15",
          rewardType: "升职",
          describe: "describedescribedescribedescribedescribe"
        },
        {
          name: "张三",
          sex: "男",
          org: "弘业祥盛街A店A组",
          post: "经纪人",
          rank: "实习经纪人",
          phone: "15512212222",
          email: "1145698765@qq.com",
          weChart: "15512212222",
          qq: "1145698765",
          emergencyContact: "赵四",
          relationship: "朋友",
          emergencyContactPhone: "18818818888",
          address: "郑州金水区熊二河路",
          nativePlace: "郑州金水区熊二河路",
          birthday: "1993-09-12",
          state: "正式员工",
          education: "本科",
          rewardutc: "2020-06-15",
          rewardType: "升职",
          describe: "describedescribedescribedescribedescribe"
        },
        {
          name: "张三",
          sex: "男",
          org: "弘业祥盛街A店A组",
          post: "经纪人",
          rank: "实习经纪人",
          phone: "15512212222",
          email: "1145698765@qq.com",
          weChart: "15512212222",
          qq: "1145698765",
          emergencyContact: "赵四",
          relationship: "朋友",
          emergencyContactPhone: "18818818888",
          address: "郑州金水区熊二河路",
          nativePlace: "郑州金水区熊二河路",
          birthday: "1993-09-12",
          state: "正式员工",
          education: "本科",
          rewardutc: "2020-06-15",
          rewardType: "升职",
          describe: "describedescribedescribedescribedescribe"
        },
        {
          name: "张三",
          sex: "男",
          org: "弘业祥盛街A店A组",
          post: "经纪人",
          rank: "实习经纪人",
          phone: "15512212222",
          email: "1145698765@qq.com",
          weChart: "15512212222",
          qq: "1145698765",
          emergencyContact: "赵四",
          relationship: "朋友",
          emergencyContactPhone: "18818818888",
          address: "郑州金水区熊二河路",
          nativePlace: "郑州金水区熊二河路",
          birthday: "1993-09-12",
          state: "正式员工",
          education: "本科",
          rewardutc: "2020-06-15",
          rewardType: "升职",
          describe: "describedescribedescribedescribedescribe"
        },
        {
          name: "张三",
          sex: "男",
          org: "弘业祥盛街A店A组",
          post: "经纪人",
          rank: "实习经纪人",
          phone: "15512212222",
          email: "1145698765@qq.com",
          weChart: "15512212222",
          qq: "1145698765",
          emergencyContact: "赵四",
          relationship: "朋友",
          emergencyContactPhone: "18818818888",
          address: "郑州金水区熊二河路",
          nativePlace: "郑州金水区熊二河路",
          birthday: "1993-09-12",
          state: "正式员工",
          education: "本科",
          rewardutc: "2020-06-15",
          rewardType: "升职",
          describe: "describedescribedescribedescribedescribe"
        },
        {
          name: "张三",
          sex: "男",
          org: "弘业祥盛街A店A组",
          post: "经纪人",
          rank: "实习经纪人",
          phone: "15512212222",
          email: "1145698765@qq.com",
          weChart: "15512212222",
          qq: "1145698765",
          emergencyContact: "赵四",
          relationship: "朋友",
          emergencyContactPhone: "18818818888",
          address: "郑州金水区熊二河路",
          nativePlace: "郑州金水区熊二河路",
          birthday: "1993-09-12",
          state: "正式员工",
          education: "本科",
          rewardutc: "2020-06-15",
          rewardType: "升职",
          describe: "describedescribedescribedescribedescribe"
        }
      ]
    };
  },
  mounted() {
    this.getpeopleList();
    this.orgSearch();
  },
  methods: {
    selectsearchDateType(val) {},
    orgSearch() {
      var val = this.org;

      // 异步
      const query = {
        search: val,
        limit: 1000
      };
      getOrgAllTree(query).then(res => {
        // //console.log("获取的组织加购", res);
        if (res.code == 1) {
          this.orgList = tree(res.data.rows);
        }
      });
    },

    setFilterDays(num) {
      let start = new Date(
        new Date(new Date().setHours(0, 0, 0, 0)).getTime() -
          24 * 60 * 60 * 1000 * num
      ).toLocaleString("chinese", { hour12: false });
      let end = new Date().toLocaleString("chinese", { hour12: false });
      this.query.dateRange = [start, end];
    },
    handleSizeChange(val) {
      //console.log("更改的页面数量", val);
      this.query.limit = val;
      this.getpeopleList();
    },
    handleCurrentChange(val) {
      //console.log("跳转的指定页", val);
      this.query.pageIndex = val;
      this.getpeopleList();
    },
    getpeopleList() {
      //console.log("获取的时间筛选", this.time);
      if (this.time != "" && this.time != null) {
        this.query.start = this.time[0];
        this.query.end = this.time[1];
      } else {
        this.query.start = "";
        this.query.end = "";
      }
    }
  }
};
</script>
<style scoped lang='scss'>
.report-main {
  margin: 20px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2);

  .main-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    height: 30px;

    .top-left {
      display: flex;
      align-items: center;
      height: 100%;

      .el-button {
        margin: 0;
        border-left-color: transparent;
        height: 30px;

        &:first-child {
          border-left-color: #dcdfe6;
        }

        &:focus {
          border: 1px solid $--color-primary;
        }
      }
    //   .vue-treeselect {
    //     margin: 0 10px;
    //     width: 150px;
    //     ::v-deep .vue-treeselect__control {
    //       border-radius: 0;
    //       height: 30px;
    //       .vue-treeselect__placeholder {
    //         color: #454a51;
    //         line-height: 30px;
    //       }
    //       .vue-treeselect__control-arrow {
    //         width: 7px;
    //         color: #888888;
    //       }
    //     }
    //     ::v-deep .vue-treeselect__menu-container{
    //         margin-top: 5px;
    //         .vue-treeselect__menu{
    //             border-radius: 0;
    //         }
    //     }
    //   }
      .el-date-editor {
        height: 30px;
        border-left-color: transparent;
      }
      .filter-date{
        border-left-color: transparent;
        &:hover{
          border-color: #ddd;
          border-left: 0px solid transparent;
        }
        &.isactive{
          border-color: $--color-primary;
        }
      }   
      .el-select {
        margin-left: 10px;
        width: 95px;
      }
    }

 
  }

  .el-table {
    font-size: 12px;
    background: #fff;
    .table-operation {
      display: flex;
      .el-button + .el-button {
        margin-left: 10px;
      }
    }
  }
  .pagination {
    padding: 15px 10px;
  }
}
</style>